export default {
  search(state, search) {
    state.search = search;
  },
  limit(state, limit) {
    state.limit = limit;
  },
  page(state, page) {
    state.page = page;
  },
  role(state, role) {
    state.role = role;
  },
  active(state, active) {
    state.active = active;
  },
  loading(state, loading) {
    state.loading = loading;
  },
  sort(state, sort) {
    state.sort = sort;
  },
  docs(state, docs) {
    state.docs = docs;
  },
  totalDocs(state, totalDocs) {
    state.totalDocs = totalDocs;
  },
  totalPages(state, totalPages) {
    state.totalPages = totalPages;
  },
};
